const apiConfig = require('../../config/api');
const axios = require('axios');
const eventBus = require('../vue/eventBus');

module.exports.createInstance = function () {
    let instance = axios.create({
        baseURL: apiConfig.dataServerURL,
        timeout: apiConfig.dataServerTimeout,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Brand-Name': apiConfig.brandName,
            'Front-Api': 'true',
        },
    });

    instance.interceptors.response.use(response => response, error => {
        let status = error && error.response && error.response.status;

        if (status === 429) {
            eventBus.bus.$emit(eventBus.events.backendApiThrottle);
        }

        if (status === 419) {
            eventBus.bus.$emit(eventBus.events.invalidUserSession);
        }
        throw error;//FALLBACK_LOCALE
    });

    return instance;
};

module.exports.createFrontInstance = function () {
    return axios.create({
        baseURL: apiConfig.frontServerURL,
        timeout: apiConfig.frontServerTimeout,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    });
};
